import { useQuery } from "@tanstack/react-query";
import { apiFetch, expectJsonBody } from "@common/lib/api";

const membershipsQueryKey = (userId: string | undefined) => ["session-account-memberships", userId] as const;

async function fetchMemberships() {
    return expectJsonBody(await apiFetch<{ account_ids: string[] }>("account/memberships"), "account/memberships");
}

export function useMemberships(userId: string | undefined) {
    return useQuery({
        queryKey: membershipsQueryKey(userId),
        queryFn: fetchMemberships,
        enabled: Boolean(userId),
        staleTime: 60_000,
        gcTime: 10 * 60 * 1000,
    });
}
